import Swiper from 'https://unpkg.com/swiper@7/swiper-bundle.esm.browser.min.js'

export class ProductSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.thumbElement = this.querySelector('.thumb-swiper-container')
    this.mainElement = this.querySelector('.product-swiper-container')
    let thumbSwiper = false;
    if (this.thumbElement) {
      thumbSwiper = new Swiper(this.thumbElement,  {
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 12,
        mousewheel: true,
        cssMode: false,
        preventClicks: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
      this.thumbElement.parentElement.classList.add('md:block')
    }

    if (this.mainElement) {
      const productSwiper = new Swiper(this.mainElement,  {
        direction: 'horizontal',
        mousewheel: true,
        cssMode: false,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        // Navigation arrows
        navigation: false,
        zoom: {
          maxRatio: 5,
          toggle: true
        },
        thumbs: {
          swiper: thumbSwiper && thumbSwiper
        },
        breakpoints: {
          768: {
            pagination: false
          }
        }
      })
      // this.mainElement.addEventListener('mouseenter', function() {
      //   productSwiper.zoom.in()
      // })
      // this.mainElement.addEventListener('mouseleave', function() {
      //   productSwiper.zoom.out()
      // })
    }
  }

}
customElements.define('product-swiper', ProductSwiper);